var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Swal from 'sweetalert2/dist/sweetalert2.min.js';
var VueSweetalert2 = (function () {
    function VueSweetalert2() {
    }
    VueSweetalert2.install = function (Vue, options) {
        options = __assign({
            includeCss: true
        }, options);
        if (options.includeCss !== false) {
            require('sweetalert2/dist/sweetalert2.min.css');
        }
        var _swal = options ? Swal.mixin(options).fire.bind(Swal) : Swal.fire.bind(Swal);
        Vue['swal'] = _swal;
        if (!Vue.prototype.hasOwnProperty('$swal')) {
            Vue.prototype.$swal = _swal;
        }
    };
    return VueSweetalert2;
}());
export default VueSweetalert2;
//# sourceMappingURL=index.js.map